const OPEN_API_NAME = "openapi";

export default OPEN_API_NAME;
